import React from 'react';

type HighlightedTextProps = {
    text: any;
    highlight: any;
};

const HighlightedText = ({ text, highlight }: HighlightedTextProps) => {
    const escapedHighlight = highlight.replace(/[^ a-zA-Z0-9]/g, '\\$&');
    const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));
    return (
        <span>
            {parts.map((part: any, i: number) => (
                <span
                    key={i}
                    style={
                        part.toLowerCase() === highlight.toLowerCase()
                            ? { background: 'rgba(116, 116, 128, 0.61)' }
                            : {}
                    }>
                    {part}
                </span>
            ))}
        </span>
    );
};

export default HighlightedText;
